import { ButtonGradientPrimary } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import { CircleCheckBigIcon, DownloadIcon } from '../PrepareMeetingIcons';

interface PrepareMeetingDownloadSectionProps {
    onDownload: () => void;
    isDisabled: boolean;
    isLoading?: boolean;
}

export const PrepareMeetingDownloadSection = ({
    onDownload,
    isDisabled,
    isLoading,
}: PrepareMeetingDownloadSectionProps) => {
    const { t } = useTranslation();

    return (
        <div
            className={
                'border-step-rail-turquoise bg-step-rail-turquoise/10 mt-20 flex flex-wrap items-center justify-between gap-4 rounded-lg border p-[24px]'
            }
        >
            <div className={'flex items-center gap-4'}>
                <div
                    className={
                        'flex h-[40px] w-[40px] items-center justify-center rounded-full bg-teal-400 text-white'
                    }
                >
                    <CircleCheckBigIcon className={'h-[24px] w-[24px] text-white'} />
                </div>
                <div>
                    <p className={'text-body! font-semibold text-gray-900'}>
                        {t('postReviewPrepareMeeting.download.title')}
                    </p>
                    <p className={'text-body-sm! text-gray-900'}>
                        {t('postReviewPrepareMeeting.download.subtitle')}
                    </p>
                </div>
            </div>
            <ButtonGradientPrimary
                onClick={onDownload}
                className={
                    'text-body! flex items-center gap-2 rounded-md bg-teal-600 px-[24px] py-[12px] font-semibold text-white hover:bg-teal-700 disabled:cursor-not-allowed disabled:opacity-60'
                }
                type={'button'}
                disabled={isDisabled || isLoading}
                leftIcon={<DownloadIcon className={'h-[20px] w-[20px]'} />}
            >
                {isLoading ? t('common.loading') : t('postReviewPrepareMeeting.download.button')}
            </ButtonGradientPrimary>
        </div>
    );
};
